import logo from "../../assets/nwt.png";
import { CREATE_ACCOUNT_HREF, HEADER_LINKS, SIGN_IN_HREF } from "./constants";
import {
  ActionLink,
  Brand,
  BrandLogo,
  HeaderActions,
  HeaderBar,
} from "./styles";

export function WelcomeHeader() {
  const sectionLinks = HEADER_LINKS.map(({ href, label }) => (
    <a className="section-link" href={href} key={href}>
      {label}
    </a>
  ));
  return (
    <HeaderBar>
      <Brand href="/" aria-label="Net Worth Tracker home">
        <BrandLogo src={logo} alt="" width={34} height={34} />
        <span>Net Worth Tracker</span>
      </Brand>
      <HeaderActions aria-label="Main navigation">
        {sectionLinks}
        <a className="signin-link" href={SIGN_IN_HREF}>
          Sign in
        </a>
        <ActionLink as="a" href={CREATE_ACCOUNT_HREF}>
          Create account
        </ActionLink>
      </HeaderActions>
    </HeaderBar>
  );
}
